import { Box, Stat, StatLabel, StatNumber, StatHelpText } from "@chakra-ui/react";
import { IconType } from "react-icons";
import React from "react";

interface KPICardProps {
  label: string;
  value: string | number;
  helpText?: string;
  icon: IconType;
  color: string;
  bgGradient?: string;
}

export const KPICard = ({ label, value, helpText, icon, color, bgGradient }: KPICardProps) => {
  return (
    <Box
      bg="white"
      p={{ base: 4, md: 6 }}
      borderRadius={{ base: "16px", md: "20px" }}
      boxShadow="0 4px 20px rgba(0, 0, 0, 0.08)"
      border="1px solid"
      borderColor="gray.100"
      position="relative"
      overflow="hidden"
      _hover={{
        transform: "translateY(-4px)",
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
      }}
      transition="all 0.3s"
    >
      {/* Background gradient accent */}
      <Box
        position="absolute"
        top={0}
        right={0}
        width="120px"
        height="120px"
        bgGradient={bgGradient || `linear(to-br, ${color}20, transparent)`}
        borderRadius="0 20px 0 100%"
        opacity={0.6}
      />

      <Box position="relative" zIndex={1}>
        <Box
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          width="50px"
          height="50px"
          borderRadius="12px"
          bg={`${color}15`}
          mb={4}
        >
          {React.createElement(icon as any, { size: 24, color: color })}
        </Box>

        <Stat>
          <StatLabel
            fontSize="sm"
            fontWeight="600"
            color="gray.600"
            textTransform="uppercase"
            letterSpacing="wide"
          >
            {label}
          </StatLabel>
          <StatNumber
            fontSize="3xl"
            fontWeight="800"
            color="#1A202C"
            mt={2}
          >
            {value}
          </StatNumber>
          {helpText && (
            <StatHelpText
              fontSize="sm"
              color="gray.500"
              fontWeight="500"
              mt={1}
            >
              {helpText}
            </StatHelpText>
          )}
        </Stat>
      </Box>
    </Box>
  );
};
